/**
 * @generated SignedSource<<6117e914dfa0c550b3ca80e560b7507f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorBioAuthor$data = {
  readonly bio: string | null | undefined;
  readonly " $fragmentType": "authorBioAuthor";
};
export type authorBioAuthor$key = {
  readonly " $data"?: authorBioAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorBioAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorBioAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "60df5b2a5058742c275bf14e27bad323";

export default node;
